<app-export-application
  [disabled]="disabled"
  [type]="type"
  [icon]="icon"
  [color]="color"
  [dealId]="dealId">
</app-export-application>